import React from "react";
import GameTipDataList from "./GameTipDataList";
import GameTipEditForm from "./GameTipEditForm";
import GameTipShowItem from "./GameTipShowItem";
import GameTipCreateForm from "./GameTipCreateForm";

///////////////////// LIST ALL GAME TIPS /////////////////////
export const GameTipList = props => <GameTipDataList {...props} />;

///////////////////// SHOW GAME TIP /////////////////////
export const GameTipShow = props => <GameTipShowItem {...props} />;

///////////////////// UPDATE GAME TIP /////////////////////
export const GameTipEdit = props => <GameTipEditForm {...props} />;

///////////////////// CREATE NEW GAME TIP /////////////////////
export const GameTipCreate = props => <GameTipCreateForm {...props} />;



// WEBPACK FOOTER //
// ./src/containers/CRM/GameTips/index.js